import React from 'react';
import styles from './PopupAttemptContact.css';

const PopupAttemptContact = ({
  increaseNumber,
  date,
  reduceNumber,
  strings,
  save }) => (
    <div className={styles.popupBody}>
      <div className={styles.attemptedContact}>
        <div className={styles.minusSymbol}>
          <button
            className={styles.symbols}
            onClick={reduceNumber}
          >-</button>
        </div>
        <div className={styles.appointmentText}>
          <div
            type="text"
            className={styles.date}
            theme={styles}
            value={date} disabled
          >
            <span className={styles.dateSpan}>{date}</span>
          </div>
        </div>
        <div className={styles.plusSymbol}>
          <button
            className={styles.symbols}
            onClick={increaseNumber}
          >
          +
          </button>
        </div>
      </div>
      <div className={styles.saveDiv}>
        <button
          className={styles.saveSpan}
          onClick={() => save('attempted_contact')}
        >
          {strings.save}
        </button>
      </div>
    </div>
);

PopupAttemptContact.propTypes = {
  increaseNumber: React.PropTypes.func,
  date: React.PropTypes.number,
  reduceNumber: React.PropTypes.func,
  strings: React.PropTypes.shape({}),
  save: React.PropTypes.func
};

export default PopupAttemptContact;



// WEBPACK FOOTER //
// ./src/components/PopupAttemptContact/PopupAttemptContact.js